import { Card } from "@postenbring/hedwig-react";
import { BodyLink, LINKTYPE_EXTERNAL, LINKTYPE_INTERNAL } from "./subcomponents/BodyLink";
import { CTAButtonGroup, LINKTYPE_CTA } from "./subcomponents/CTAButtonGroup";
import { ImageIllustration } from "./subcomponents/ImageIllustration";
import { VideoOverlay } from "./subcomponents/VideoOverlay";

import "./kp-cards.scss";

export const FullWidthCard = ({
    dataColorScheme,
    buttons,
    imageUrl,
    imageAltText,
    imagePosition,
    focalPointStyle,
    isIllustration,
    isAnimatedGif,
    pauseImageUrl,
    pauseAnimationLabel,
    playAnimationLabel,
    header,
    title,
    description,
    linkOrButtons, // backward compatibility
    theme,
    dataColor,
    variant,
    videoUrl,
}) => {
    const firstLinkOrCtaType = linkOrButtons?.[0]?.type;

    return (
        <Card
            variant="full-width"
            // Add extra class for marking the default color, used in postenbring app to override the theme
            // className={backgroundColor === "lighter-brand" ? "hds-card--color-lighter" : undefined}
            //color={backgroundColor}
            theme={theme}
            data-color={dataColor}
            imagePosition={imagePosition}
            {...(dataColorScheme ? { "data-color-scheme": dataColorScheme } : {})}
        >
            {imageUrl && !videoUrl && (
                <ImageIllustration
                    imageUrl={imageUrl}
                    imageAltText={imageAltText}
                    isIllustration={isIllustration}
                    focalPointStyle={focalPointStyle}
                    isAnimatedGif={isAnimatedGif}
                    pauseImageUrl={pauseImageUrl}
                    pauseAnimationLabel={pauseAnimationLabel}
                    playAnimationLabel={playAnimationLabel}
                />
            )}
            {videoUrl && (
                <VideoOverlay
                    videoUrl={videoUrl}
                    imageUrl={imageUrl}
                    imageAltText={imageAltText}
                    isIllustration={isIllustration}
                    focalPointStyle={focalPointStyle}
                />
            )}
            <Card.Body>
                {(header || title) && (
                    <Card.BodyHeader>
                        {header && <Card.BodyHeaderOverline>{header}</Card.BodyHeaderOverline>}
                        {title && (
                            <Card.BodyHeaderTitle as="h2" variant="h2">
                                {title}
                            </Card.BodyHeaderTitle>
                        )}
                    </Card.BodyHeader>
                )}
                {description && <Card.BodyDescription>{description}</Card.BodyDescription>}
                {firstLinkOrCtaType === LINKTYPE_INTERNAL ||
                firstLinkOrCtaType === LINKTYPE_EXTERNAL ? (
                    <BodyLink {...linkOrButtons[0]} inverted={variant === "focus"} />
                ) : firstLinkOrCtaType === LINKTYPE_CTA ? (
                    <CTAButtonGroup buttons={linkOrButtons} inverted={variant === "focus"} />
                ) : null}
                {buttons && <CTAButtonGroup buttons={buttons} inverted={variant === "focus"} />}
            </Card.Body>
        </Card>
    );
};
